/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type plan_updatetobeadmitted_MutationVariables = {|
  planId: any,
  toBeAdmitted: boolean,
|};
export type plan_updatetobeadmitted_MutationResponse = {|
  +planMutation: ?{|
    +updateToBeAdmitted: ?{|
      +id: string,
      +toBeAdmitted: ?boolean,
    |}
  |}
|};
export type plan_updatetobeadmitted_Mutation = {|
  variables: plan_updatetobeadmitted_MutationVariables,
  response: plan_updatetobeadmitted_MutationResponse,
|};
*/


/*
mutation plan_updatetobeadmitted_Mutation(
  $planId: UUID!
  $toBeAdmitted: Boolean!
) {
  planMutation {
    updateToBeAdmitted(planId: $planId, toBeAdmitted: $toBeAdmitted) {
      id
      toBeAdmitted
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "planId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toBeAdmitted"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PlanMutation",
    "kind": "LinkedField",
    "name": "planMutation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "planId",
            "variableName": "planId"
          },
          {
            "kind": "Variable",
            "name": "toBeAdmitted",
            "variableName": "toBeAdmitted"
          }
        ],
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "updateToBeAdmitted",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "toBeAdmitted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "plan_updatetobeadmitted_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "plan_updatetobeadmitted_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "256930bac376d43beab4188df2a70d9e",
    "id": null,
    "metadata": {},
    "name": "plan_updatetobeadmitted_Mutation",
    "operationKind": "mutation",
    "text": "mutation plan_updatetobeadmitted_Mutation(\n  $planId: UUID!\n  $toBeAdmitted: Boolean!\n) {\n  planMutation {\n    updateToBeAdmitted(planId: $planId, toBeAdmitted: $toBeAdmitted) {\n      id\n      toBeAdmitted\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '079cdd3c5884d7136ee31f6bc776058e';

module.exports = node;
